var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import { ApolloLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { service } from '@ember/service';
import ApolloBaseService from 'ember-apollo-client/services/apollo';
let ApolloService = (_class = class ApolloService extends ApolloBaseService {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "cookies", _descriptor, this);
    _initializerDefineProperty(this, "metrics", _descriptor2, this);
  }
  clientOptions() {
    const errorLink = this.errorLink;
    const csrfLink = this.csrfLink();
    const httpLink = this.httpLink();
    // Ensure all links are defined before composing
    const links = [errorLink, csrfLink, httpLink];
    return {
      link: ApolloLink.from(links),
      cache: this.cache()
    };
  }
  get errorLink() {
    return onError(({
      graphQLErrors
    }) => {
      if (graphQLErrors) {
        graphQLErrors.forEach(({
          message
        }) => {
          // Send error details to Datadog
          this.metrics.logMonitorEvent('DASHBOARD_GQL_ERROR', {
            message
          });
        });
      }
    });
  }
  csrfLink() {
    return setContext(() => ({
      headers: {
        'X-CSRF-Token': this.cookies.read('csrf_token')
      }
    }));
  }
  httpLink() {
    return super.link();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cookies", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "metrics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export default ApolloService;